module.exports = __webpack_public_path__ + "img/Hängepartie.ca7f9037.jpg";